import styled from "styled-components"

const CutOffTriangle = styled.div`
  width: 0;
  height: 0;
  border-style: solid;
  position: absolute;
  bottom: 0;
  border-width: 0 0 50px 1920px;
  border-color: transparent transparent ${({theme}) => theme.colors.greys.white} transparent;
`

export default CutOffTriangle
